import type { PlayApi, PlaySession } from '@mogzo/play';
import { API_URL, apiFetch } from './api';

/** Play sessions on mogzo.com: from the player's own sign-in, for games they may play. */
export const webPlayApi: PlayApi = {
  apiUrl: API_URL,
  startSession: (projectId) =>
    apiFetch<PlaySession>('/v1/play/session', {
      method: 'POST',
      body: JSON.stringify({ projectId }),
    }),
};
